import { useRouteMatch } from 'react-router-dom';

export const i18nPublicPaths = [
  '/app/:team_schema/p',
  '/app/:app_id/arrivals'
] as const;

export const useRouteMatchesPublicPaths = () =>
  i18nPublicPaths.map(useRouteMatch).some(Boolean);
